module.exports = __webpack_public_path__ + "37e150e8743189b7750434b33fc46fec.svg";